import {Component, OnInit, Inject, Input} from 'ng-metadata/core';
import {ExportExcelService} from './exportExcel.service';
import {saveAs} from 'file-saver';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {getVid} from '../../../appConfig/appConfigForward';

@Component({
    selector: 'prm-export-excel',
    templateUrl: 'components/search/actions/exportExcelAction/export-excel.html',
})

export class PrmExportExcel implements OnInit{
     
    @Input() public selectedIds: Object;
    @Input() private item: any;

    private vid = getVid(); 
    private formatVal:string;
    private formatList: string[] = ['xlsx','csv'];
    private EXCEL_API_URL: string;
    private PNX_API_URL: string;
    private payload: Object = {};
    private buildPayloadInProgress: boolean = true;
    
    constructor(private exportExcelService: ExportExcelService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$q') private $q: ng.IQService,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$http') private $http: ng.IHttpService) {
                let pushToSuffix = this.configurationUtil.isSuprima() ? '' : '/pushto';
                this.EXCEL_API_URL = restBaseURLs.actionsBaseURL + pushToSuffix + '/excel';
                this.PNX_API_URL = restBaseURLs.actionsBaseURL + pushToSuffix + '/getPnx' + '?vid=' + this.vid;      
    }
    
    ngOnInit() {
      this.buildPayload();
    }

    public getFile(){
        this.payload.format = this.formatVal || 'xlsx';
        let config = {
            headers: {'Accept': this.getMimeType() + ',text/plain; q=0.5'},
            responseType: 'arraybuffer'
		};
        this.$http.post(this.EXCEL_API_URL, this.payload, config).then((response)=>{
            let blob = new Blob([response.data], {type: this.getMimeType()});
            let filename = this.exportExcelService.getFileNameFromHttpResponse(response);
            saveAs(blob, filename);
         },(err)=>{console.error('Error in getting Excel file: ' + err)});   
    }

    public async buildPayload(){
        if(this.selectedIds && !this.item){
            let selectedIdsPnx = await this.getPnxFromSelectedIds();
            this.item = selectedIdsPnx.data;
        }

        let rtl = false;
        if (this.exportExcelService.getLayoutDirection() === 'rtl'){
            rtl = true;
        }
        this.payload.rtl = rtl;
        let promiseArray = [];
        promiseArray.push(this.exportExcelService.getAvailableFields());
        promiseArray.push(this.$translate('fulldisplay.command.permalink'));
        promiseArray.push(this.exportExcelService.getItemsPermalinks(this.item));
        promiseArray = promiseArray.concat(this.exportExcelService.getItemsDetails(this.item));
        this.$q.all(promiseArray).then((parts)=>{
            let headers = parts[0];
            let permalinkHeader = {};
            permalinkHeader.translation = parts[1];
            permalinkHeader.order = Object.keys(headers).length;
            headers.permalink = permalinkHeader;
            this.payload.headers = headers
            this.payload.permalinks = parts[2].data;
            this.payload.records = parts.splice(3);
            this.payload.records.forEach((record, index) => {
                for (let field in record) {
                    record[field] = this.sanitizeHtmlTags(record[field]);
                }
            });
        },
        (err)=>{console.error('Payload build failed: ' + err)})
        .finally(() =>{this.buildPayloadInProgress = false;});
    }

    private sanitizeHtmlTags(str: string) {
        return str.replace(/<\/?[^>]+(>|$)/g, '');
    }

    private getPnxFromSelectedIds(){
        let records = {};
        records.records = this.selectedIds;
        return this.$http.post(this.PNX_API_URL, records);
    }

    private getMimeType(): string{
        return this.formatVal === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/exportExcelAction/exportExcel.directive.ts